import { Component, OnInit } from '@angular/core';
import { NowcastRainfallService } from './utils/service/nowcast-rainfall.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { ConstantsModule } from '../../shared/constants/constants.module';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { NowcastRFConstants } from './utils/constant/nowcast-rainfall-map.constant';
import { RainfallConstants } from '../forecast-rainfall/utils/constant/rainfall-map.constant';
import { MapService } from './utils/service/map.service';
import { isNullOrUndefined } from 'util';
import { MapConstants } from 'src/app/utils/map.constant';
import { NowcastDataService } from '../../side-bar/nowcast-dashboard-v2/nowcast/nowcast-data.service';
import { NowcastMapConstants } from '../../side-bar/nowcast-dashboard-v2/nowcast/nowcast-map/nowcast-map-constants';
import { resolve } from 'url';

@Component({
  selector: 'app-nowcast-rainfall',
  templateUrl: './nowcast-rainfall.component.html',
  styleUrls: ['./nowcast-rainfall.component.scss']
})
export class NowcastRainfallComponent implements OnInit {

  component: any;
  layerList: any[];
  stateName: any;
  otherOptions: {};
  sourceSelected: any;
  primary: any;
  secondary: any;
  initializeBool = true;
  stateId = 'akbm';

  constructor(
    private nowcastRfService: NowcastRainfallService,
    private utilService: UtilsService,
    public constants: ConstantsModule,
    private nowcastDataSrv: NowcastDataService
  ) {
    this.stateName = ProjConstants.IDTOSTATENAMEMAPPING[this.stateId];
  }

  ngOnInit() {
    this.component = 'NOWCAST';
    this.sourceSelected = 'IMD (GFS)';
    // this.primary = this.constants.SOURCE_WISE[
    //   this.sourceSelected
    // ].PrimarySourceType;
    // this.secondary = this.constants.SOURCE_WISE[
    //   this.sourceSelected
    // ].SecondarySourceType;
    this.getLayersList(NowcastRFConstants.CommonLayers);
    this.getOtherOptions();
    this.otherOptions['reloadAllTimeLayers'] = true;
    this.utilService.setDetermisnisticOrEnsemble('deterministic');
  }

  ngOnDestroy() { }

  async getLayersList(layers) {
    let layerList = [];
    layerList = layerList.concat(this.getCommonLayers(layers));
    this.layerList = layerList;
    layerList = layerList.concat(await this.createHeatMapLayers());
    console.log(layerList, "layerlist123");
    this.layerList = layerList;

  }

  getOtherOptions() {
    const otherOptions = {};
    otherOptions['legend'] = RainfallConstants.Legend;
    otherOptions['weeklyLegend'] = RainfallConstants.Legend;
    otherOptions['service'] = MapService;
    otherOptions['changeStateBoolean'] = false;
    otherOptions['reloadAllTimeLayers'] = false;
    otherOptions['addInverseMask'] = false;
    this.otherOptions = otherOptions;
    this.utilService.setOtherOptions(otherOptions);
  }

  getCommonLayers(layers) {
    const layerList: any = layers;
    for (const i in layerList) {
      if (!isNullOrUndefined(i)) {
        const layer = layerList[i];
        layer['stateName'] = this.stateName;
        if (layer.layerNameType) {
          if (layer['serviceType'] === 'VectorLayer') {
            layer['layerName'] =
              ProjConstants.STATE_TO_LAYERTYPE_NAME[
              this.stateName + '_' + layer.layerNameType
              ];
          } else {
            layer['layerName'] =
              MapConstants.GEOSERVER_WORKSPACE_NAME +
              ':' +
              ProjConstants.STATE_TO_LAYERTYPE_NAME[
              this.stateName + '_' + layer.layerNameType
              ];
          }
        }
      }
    }
    return layerList;
  }

  // getHeatMapLayers() {
  //   let layerList = [];
  //   layerList = layerList.concat(this.create10HeatMapLayers());
  //   return layerList;
  // }

  getHeatMapLayers() {
    return new Promise((resolve, reject) => {
      this.nowcastDataSrv.getHeatMapData('IMD_RADAR_NOWCAST').subscribe(resp => {
        if (!isNullOrUndefined(resp) && Object.keys(resp).length > 0) {
          resolve(resp)
        } else {
          resolve({})
        }
      }, err => {
        resolve({})
      })
    })
  }

  async createHeatMapLayers() {
    let heatMapsData = await this.getHeatMapLayers()
    const urls: any = [];
    let data = await Promise.all([heatMapsData]).then(async (payloads) => {
      let heatmapData = await payloads[0];
      if (heatmapData && Object.keys(heatmapData).length > 0) {
        const tsarray: any = this.nowcastDataSrv.getNext5HrsTimeStampsWithHeatMaps(heatmapData, 'IMD RADAR');
        for (const i in tsarray) {
          const layerObj = { ...NowcastMapConstants.HeatMapOptions };
          layerObj['url'] = tsarray[i]['url']
          layerObj['groupName'] = tsarray[i]['timeStamp'].toString();
          if (i == '5') {
            layerObj['setDefault'] = 'true';
            this.otherOptions['timestamp'] = this.nowcastDataSrv.formatDateString(Number(tsarray[i]['timeStamp']));
            layerObj['time'] = '10';
            layerObj['view'] = 'Admin';
            layerObj['imageBounds'] = this.nowcastDataSrv.getImageBounds(this.nowcastDataSrv.getHeatMapImageBounds(tsarray[i]['heatMapImageBound']));
            layerObj['timeLineName'] = tsarray[i]['timeLineName'];
            layerObj['timeLinePos'] = tsarray[i]['timeLinePos'];
            layerObj['leftSideName'] = tsarray[i]['timeLineName']['toolTip']
            layerObj['layerName'] = 'Nowcast Heatmap';
            urls.push(layerObj);
          }
        }
      }
    });
    return urls
  }

}
